import { RouteType } from "types/RouteType";
import meetingsRoute from "./Meetings/meetings.Route";
import internalMeetingsRoute from "./InternalMeetings/internalMeetings.Route";
import meetingDetailRoute from "./MeetingDetail/meetingDetail.Route";
import reviewQueueRoute from "./ReviewQueue/reviewQueue.Route";
import readAiSettingsRoute from "./Settings/readAiSettings.Route";
import partnersRoute from "./Partners/partners.Route";
import partnerDetailRoute from "./PartnerDetail/partnerDetail.Route";
import domainMappingsRoute from "./DomainMappings/domainMappings.Route";
import meetingSourcesRoute from "./MeetingSources/meetingSources.Route";
import deliveryConnectionsRoute from "./DeliveryConnections/deliveryConnections.Route";
import mappingQueueRoute from "./MappingQueue/mappingQueue.Route";
import analysisQueueRoute from "./AnalysisQueue/analysisQueue.Route";
import routingIssuesRoute from "./RoutingIssues/routingIssues.Route";
import assignmentDetailRoute from "./AssignmentDetail/assignmentDetail.Route";

const meetingIntelligenceRoutesList: RouteType[] = [
  ...meetingsRoute,
  ...internalMeetingsRoute,
  ...meetingDetailRoute,
  ...reviewQueueRoute,
  ...readAiSettingsRoute,
  ...partnersRoute,
  ...partnerDetailRoute,
  ...domainMappingsRoute,
  ...meetingSourcesRoute,
  ...deliveryConnectionsRoute,
  ...mappingQueueRoute,
  ...analysisQueueRoute,
  ...routingIssuesRoute,
  ...assignmentDetailRoute,
];

export default meetingIntelligenceRoutesList;
